<template>
  <div>
    <BaseModal
      name="checkCertificate"
      width="420"
      height="auto"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="tw-app-modal !tw-overflow-visible"
      @before-close="beforeClose()"
    >
      <div
        class="tw-app-modal__container"
      >
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('checkCertificate')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["company_employee_sertificate_text2"] }}
          </div>

          <div v-if="notFound">
            <div class="tw-mb-[15px]">
              {{ dataLang["company_employee_sertificate_text5"] }}
            </div>
            <div>
              {{ dataLang["company_employee_sertificate_text6"] }}
            </div>

            <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
              <button
                @click="$modal.hide('checkCertificate')"
                class="tw-app-btn-muted tw-app-btn-muted-lg"
              >
                Закрыть
              </button>
            </div>
          </div>
          <div v-else>
            <div class="tw-mb-[15px]">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["company_employee_sertificate_text3"] }}
              </div>

              <BaseInputNew
                @keyupEnter="submit()"
                inputClass="tw-app-input-type-3"
                class="tw-mb-[6px]"
                :value="search"
                @input="search = $event.value"
              />
            </div>

            <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
              <button
                @click="$modal.hide('checkCertificate')"
                class="tw-app-btn-muted tw-app-btn-muted-lg"
              >
                Отменить
              </button>
              <button
                @click="submit()"
                class="tw-app-btn-primary tw-app-btn-primary-lg"
                :disabled="submitting"
              >
                {{ dataLang["company_employee_sertificate_text4"] }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="certificate"
      width="520"
      height="auto"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="!tw-bg-transparent !tw-shadow-none !tw-overflow-visible"
      @before-close="beforeCloseCertificate()"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('certificate')"
        ></button>

        <div v-if="certificate" class="tw-text-center tw-text-black">
          <img
            :src="require(`@/assets/images/logo2.svg`)"
            class="tw-w-full tw-max-w-[340px] tw-mb-[32px]"
          />

          <div class="tw-text-[32px] tw-font-semibold tw-mb-[32px]">
            {{ dataLang["company_employee_sertificate_text7"] }}
          </div>

          <div class="tw-text-[32px]">
            {{ certificate.fio }}
          </div>

          <div class="tw-text-[24px] tw-mb-[30px]">
            {{ dataLang["company_employee_sertificate_text8"] }}
            {{ certificate.passport }}
          </div>

          <div class="tw-text-[24px]">
            {{ dataLang["company_employee_sertificate_text9"] }}<br />
            {{ dataLang["company_employee_sertificate_text10"] }}:
            {{ certificate.level }}/10
          </div>

          <div class="tw-text-[18px] tw-my-[30px]">
            {{ dataLang["company_employee_sertificate_text11"] }}:
            {{ certificateLifeTo }}
          </div>

          <div
            class="tw-inline-block tw-text-[20px] tw-text-[#0056AF] tw-py-[20px] tw-px-[30px] tw-border-[#0056AF] tw-border-solid tw-border-[3px] tw-rounded-[5px] tw-leading-[20px] tw-uppercase"
          >
            {{ dataLang["company_employee_sertificate_text12"] }}
          </div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[30px] tw-justify-center">
            <button
              @click="$modal.hide('certificate')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <button
      class="tw-app-btn-primary tw-app-btn-primary-lg"
      @click="$modal.show('checkCertificate')"
    >
      {{ dataLang["company_employee_sertificate_text1"] }}
    </button>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import dayjs from "dayjs";
import GeneralService from "@/api/GeneralService";

export default {
  data() {
    return {
      search: null,
      certificate: null,
      submitting: false,
      notFound: null,
    };
  },
  computed: {
    certificateLifeTo() {
      return dayjs(this.certificate.life_to)
        .utc(true)
        .utcOffset(Number(this.userSetting.company__utc))
        .format(`${this.userSetting.company__tempalte_date}`);
    },
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
  },
  methods: {
    beforeCloseCertificate() {
      this.certificate = null;
    },
    beforeClose() {
      this.notFound = null;
      this.search = null;
    },
    submit() {
      this.submitting = true;
      GeneralService.editOrCreate(`/super/companies/tab/sertificate/search`, {
        search: this.search,
      })
        .then((data) => {
          this.certificate = data.data.data;
          this.$modal.hide("checkCertificate");
          this.$modal.show("certificate");
        })
        .catch((e) => {
          if (e.response.data.code == 404) {
            this.notFound = true;
          } else {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
